import { Component, Inject, OnInit, OnDestroy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router } from '@angular/router';
import { MAT_DIALOG_DATA, MatDialog, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { EligibilityService } from '../../../services/eligibility.service';
import { EnquiryDialogComponent } from '../enquiry-dialog/enquiry-dialog.component';

// The possible final reveal outcomes shown in the popup.
export type ResultOutcome = 'likely' | 'hard-to-say' | 'unlikely' | 'credit-issues';

export interface ResultDialogData {
  outcome: ResultOutcome;
}

// The "Calculating..." spinner shows for a random time in this range before revealing the result.
const CALCULATING_MIN_MS = 750;
const CALCULATING_MAX_MS = 3000;

@Component({
  selector: 'app-result-dialog',
  standalone: true,
  imports: [
    CommonModule,
    MatDialogModule,
    MatButtonModule,
    MatIconModule
  ],
  templateUrl: './result-dialog.component.html',
  styleUrl: './result-dialog.component.scss'
})
export class ResultDialogComponent implements OnInit, OnDestroy {
  calculating = true;
  private timer: ReturnType<typeof setTimeout> | null = null;

  get outcome(): ResultOutcome {
    return this.data.outcome;
  }

  constructor(
    public dialogRef: MatDialogRef<ResultDialogComponent>,
    @Inject(MAT_DIALOG_DATA) private data: ResultDialogData,
    private eligibilityService: EligibilityService,
    private router: Router,
    private dialog: MatDialog
  ) {}

  ngOnInit(): void {
    const delay = CALCULATING_MIN_MS + Math.random() * (CALCULATING_MAX_MS - CALCULATING_MIN_MS);
    this.timer = setTimeout(() => {
      this.calculating = false;
    }, delay);
  }

  ngOnDestroy(): void {
    if (this.timer) {
      clearTimeout(this.timer);
    }
  }

  applyNow(): void {
    this.dialogRef.close();
    this.eligibilityService.applyNow();
  }

  getInTouch(): void {
    this.dialogRef.close();
    this.dialog.open(EnquiryDialogComponent, {
      panelClass: 'enquiry-dialog-panel',
      width: '640px',
      maxWidth: '95vw'
    });
  }

  close(): void {
    this.dialogRef.close();
  }
}
